<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>Rispondi al sondaggio</h2>
    <div fxLayout="column" class="responsive-mat-form">
      <form [formGroup]="form" fxLayout="column">

        <mat-card-title>{{ sondaggio?.titolo }}</mat-card-title>
        <mat-card-subtitle>Creato da: {{ sondaggio?.creatore.nome }} {{ sondaggio?.creatore.cognome }}</mat-card-subtitle>
        <mat-card-content>
          <div>
            <b *ngIf="sondaggio?.descrizione">{{ sondaggio?.descrizione }}</b><span *ngIf="isMultiple()"> ({{ sondaggio?.numMaxRisposte }} risposte massime)</span>
          </div>

          <ng-container *ngIf="isMultiple()">
            <mat-selection-list multiple="true" color="primary" formControlName="risposte">
              <mat-list-option *ngFor="let o of sondaggio?.options" [value]="o.id" [disabled]="disableOption(o)">
                <span>{{ o.name }}</span>
              </mat-list-option>
            </mat-selection-list>
          </ng-container>
          <ng-container *ngIf="!isMultiple()">
            <mat-selection-list multiple="false" color="primary" formControlName="risposte">
              <mat-list-option *ngFor="let o of sondaggio?.options" [value]="o.id" [disabled]="disableOption(o)">
                <span>
                  <mat-icon fxFlex="10">
                    {{ isChecked(o) ? 'radio_button_checked' : 'radio_button_unchecked' }}
                  </mat-icon>
                  {{ o.name }}
                </span>
              </mat-list-option>
            </mat-selection-list>
          </ng-container>

          <h3>{{(isSondaggioExpired()) ? 'Sondaggio scaduto' : 'Scadenza ' + ( sondaggio?.dataScadenza | date : 'dd/MM/yyyy':'' : locale | titlecase) }}</h3>
        </mat-card-content>
      </form>
    </div>
    <mat-card-actions>
      <button mat-raised-button (click)="backConfirm(previousUrl)" color="primary">Back</button>
      <button mat-raised-button (click)="submit()" [disabled]="disableSubmit()">Rispondi</button>
    </mat-card-actions>
  </mat-card-content>
</mat-card>
